// 대시보드용 "배포 대기 draft / 검증 실패" 요약. 각 콘텐츠 타입의 draft 문서 존재 여부만 가볍게
// 확인하고(문서 하나씩, 무거운 청크 다운로드는 하지 않는다), FAQ/홈/건물/시설/override/기능설정은
// 이미 가져온 draft 데이터로 바로 검증까지 돌린다(추가 읽기 없음). 셔틀도 동일하게 처리한다.
// 보행 그래프는 draft 존재만 센다(전체 청크를 검증하려면 비용이 크므로 대시보드 요약 범위에서 제외).
import { doc, getDoc } from 'firebase/firestore'
import { requireDb } from './data'
import { validateCmsDraft } from '../../../../packages/validation/cms'
import { validateShuttleData } from '../../../../src/utils/validateShuttleData'

const CMS_CONTENT_TYPES_FOR_SUMMARY = ['faq', 'homeConfig', 'buildings', 'facilities', 'cafeteriaOverrides', 'noticeOverrides', 'featureSettings']

const CONTENT_LABELS = {
  faq: 'FAQ', homeConfig: '홈 화면', buildings: '건물', facilities: '시설',
  cafeteriaOverrides: '학식 override', noticeOverrides: '공지 override', featureSettings: '기능 설정',
  shuttle: '셔틀', campusGraph: '보행 그래프',
}

export async function fetchCmsDraftSummary() {
  const db = requireDb()
  const pendingDrafts = []
  const validationFailures = []
  const readErrors = []

  await Promise.all(CMS_CONTENT_TYPES_FOR_SUMMARY.map(async contentType => {
    try {
      const snapshot = await getDoc(doc(db, 'cmsContent', contentType, 'draft', 'current'))
      if (!snapshot.exists()) return
      pendingDrafts.push({ contentType, label: CONTENT_LABELS[contentType], to: contentTypeRoute(contentType) })
      const data = snapshot.data()?.data
      if (!validateCmsDraft(contentType, data).valid) validationFailures.push({ contentType, label: CONTENT_LABELS[contentType], to: contentTypeRoute(contentType) })
    } catch { readErrors.push(contentType) }
  }))

  try {
    const shuttleSnap = await getDoc(doc(db, 'adminContent', 'shuttleDraft'))
    if (shuttleSnap.exists() && shuttleSnap.data()?.main) {
      pendingDrafts.push({ contentType: 'shuttle', label: CONTENT_LABELS.shuttle, to: '/shuttle' })
      if (!validateShuttleData(shuttleSnap.data().main).ok) validationFailures.push({ contentType: 'shuttle', label: CONTENT_LABELS.shuttle, to: '/shuttle' })
    }
  } catch { readErrors.push('shuttle') }

  try {
    const graphSnap = await getDoc(doc(db, 'campusGraphContent', 'draft'))
    if (graphSnap.exists()) pendingDrafts.push({ contentType: 'campusGraph', label: CONTENT_LABELS.campusGraph, to: '/map' })
  } catch { readErrors.push('campusGraph') }

  return { pendingDrafts, validationFailures, readErrors }
}

function contentTypeRoute(contentType) {
  if (contentType === 'faq') return '/faq'
  if (contentType === 'homeConfig') return '/home-config'
  if (contentType === 'buildings' || contentType === 'facilities') return '/map'
  if (contentType === 'cafeteriaOverrides' || contentType === 'noticeOverrides') return '/cafeteria-notice'
  if (contentType === 'featureSettings') return '/feature-settings'
  return '/dashboard'
}
